// Confirmation message shown when saving a challenge as draft.
// This message should clearly explain the consequences to the user.
const DRAFT_CONFIRM_MESSAGE = "This challenge is in DRAFT mode. The Publish Date will be ignored until you disable DRAFT mode."
import { Controller } from "stimulus"

// Connects to data-controller="confirm-if-draft"
export default class extends Controller {
    static targets = ["draftCheckbox", "submit"]

  connect() {
  this.toggle() // Run once on load in case there's an initial value
  }

  toggle() {
    // Always show confirmation if draft is true (checked)
    if (this.draftCheckboxTarget.checked) {
      // this.submitTarget.setAttribute("data-confirm", DRAFT_CONFIRM_MESSAGE)
      this.submitTarget.setAttribute("data-turbo-confirm", DRAFT_CONFIRM_MESSAGE);
    } else {
      // this.submitTarget.removeAttribute("data-confirm")
      this.submitTarget.removeAttribute("data-turbo-confirm");
    }
  }

  markInteracted() {
    // dataset properties must be strings, not booleans
  this.draftCheckboxTarget.dataset.interacted = "true"
  this.toggle()
  }
}
